﻿import { defineComponent } from 'vue';
import header_menu from "../header/menu.vue"
import hero from "../header/hero.vue"
import footer_item from "../base/common/footer.vue"
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

import basket from "../base/common/basket.vue"

import documentation from "../base/5_confirmation/documentation.vue"
import trip_summary from "../base/5_confirmation/summary.vue"
import { client_booking } from '../../objects/v1_2/Booking_Details/client_booking';

import { Booking } from "../../services/booking";
import { Payment } from "../../services/payment";
import { response_login_payment } from "../../objects/agent/identity/v1_3/response_login_payment";

import { booking_search_group } from "../../objects/v1_2/Booking_Details/booking_search_group";
import { response_booking } from "../../objects/v1_3/booking/search/response_booking";
import { Product } from '../../services/product';
import { Date_Service } from "../../../system/services/date_service";
import { Currency_Service } from "../../../system/services/currency";
import { booking_info } from '../../objects/v1_2/Booking_Details/booking_info';
import { request_payment_initialise_internal } from "../../objects/v1_3/payment/initialise/request_payment_initialise_internal";

const Prod: Product = new Product();
const Book: Booking = new Booking();
const Pay: Payment = new Payment();
const Date_Services: Date_Service = new Date_Service();
const Currency_Services: Currency_Service = new Currency_Service();

export default defineComponent({
    components: {
        footer_item,
        header_menu,
        hero,
        basket,
        documentation,
        trip_summary
    },
    data() {
        return {
            gtag_purchased: false as Boolean,
            group_booking_id: 0 as number
        }
    },
    methods: {
        async download_booking(): Promise<void> {
            this.group_booking_id = this.$store.getters.get_Booking?.group_booking_id;

            let booking_details_old = await Book.Get_Book(this.group_booking_id.toString(), this.$store.getters.get_Agent_Login)
            let session_id = booking_details_old.session_id ?? "";

            let booking_details = await Book.Get_Booking_Session(this.$store, this.group_booking_id.toString(), session_id).then((response) => {
                return response;
            });

            //retrieve the payment session from the store and update it with the latest payment booking details
            let payment_session_old : request_payment_initialise_internal = this.$store.getters.get_Payment_Session;
            let provider = payment_session_old?.provider_name ?? "";
            let app_id = this.get_Payment_App_Id();
            let payment_session_id = payment_session_old.payment_session?.toString() ?? "";
            let payment_session : request_payment_initialise_internal = await Pay.Get_Payment_Session(this.$store, payment_session_id, provider, app_id);
            payment_session.provider_name = provider;

            if (booking_details.trips != null && booking_details.trips.length > 0) {
                payment_session.get_booking.trips = booking_details.trips;
            } else {
                booking_details = payment_session.get_booking;
            }
            this.$store.commit('Payment_Session', { Payment_Session: payment_session });

            let selected_payment_method : response_login_payment = this.$store.getters.get_Selected_Payment;
            selected_payment_method.method = 'CC';
            selected_payment_method.nett_gross = (payment_session.payment_initialise.nett_sale == true) ? "N" : "G";
            selected_payment_method.description = 'CreditCard';
            selected_payment_method.provider = provider;
            this.$store.commit("Set_Payment_Selected", { Selected_Payment: selected_payment_method});

            //this caused the booking details to lose the trips details for some reason, so switched to using the booking details from the payment session which retains the trip details. Not sure why this is the case, but it may be related to how the booking details are stored in the store and how they are updated.
            this.$store.commit("Setup_Booking", { Booking_Details: booking_details });

            if (this.isValidView()) {
                this.gtag_purchase();
            }
        },
        get_group_booking_id() : number {
            return this.$store.getters.get_Booking?.group_booking_id;
        },
        saveElement2PDF() {
            const doc = new jsPDF('p', 'mm', 'a4');

            let gbid = this.$store.getters.get_Booking?.group_booking_id;

            var elementHTML = document.querySelector('#main');
            doc.html(elementHTML, {
                callback: function (doc) {
                    doc.save('Booking_Confirmation_' + gbid + '.pdf');
                },
                margin: [12, 12, 12, 12],
                autoPaging: 'text',
                x: 0,
                y: 0,
                width: 186,
                windowWidth: 744
            },);
        },
        savePage2PDF() {
            const doc = new jsPDF('p', 'mm', 'a4');

            let gbid = this.$store.getters.get_Booking?.group_booking_id;

            html2canvas(document.querySelector('#main')).then((canvas) => {
                const imgData = canvas.toDataURL("image/png");
                const imgWidth = 210; // A4 size width in mm
                const pageHeight = 295; // A4 size height in mm
                const imgHeight = (canvas.height * imgWidth) / canvas.width;
                let leftHeight = imgHeight;

                let position = 0;

                doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                leftHeight -= pageHeight;

                while (leftHeight >= 0) {
                    position = leftHeight - imgHeight;
                    doc.addPage();
                    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                    leftHeight -= pageHeight;
                }

                doc.save('Booking_Confirmation_' + gbid + '.pdf');
            });

        },
        get_Payment_App_Id(): string {
            let payment_app_id : any = import.meta.env.VITE_PAYMENT_APP_ID; //default
            if (this.$store.getters.get_Payment_APP_ID != null && this.$store.getters.get_Payment_APP_ID != '') {
                payment_app_id = this.$store.getters.get_Payment_APP_ID; //set by paylink
            }
            return payment_app_id;
        },
        show_FloDesk(): boolean {
            return import.meta.env.VITE_FLODESK_URL && import.meta.env.VITE_FLODESK_URL !== "";
        },
        getSubtitle(): string {
            return "Your booking reference number is <strong class='book-ref'>#" + this.group_booking_id + "</strong>";
        },
        getHeroImage(): string {
            return String(import.meta.env.VITE_DEFAULT_HERO_IMAGE);
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        getConfirmationText(): string {
            return String(import.meta.env.VITE_DEFAULT_CONFIRMATION_TEXT);
        },
        isMobile(): boolean{
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        getFloDeskURL(): string {
            return String(import.meta.env.VITE_FLODESK_URL);
        },
        isValidView(): boolean {
            if(this.group_booking_id == undefined || this.group_booking_id == 0 || this.group_booking_id == null) {
                return false;
            }
            return true;
        },
        home_Click() {
            this.$router.push('/');
        },
        get_Trips(): booking_info[]  {
            let Trips: booking_info[] = [];
            
            this.get_booking()?.trips?.forEach((Trip:booking_info) => {
                Trips.push(Trip);
            });
            return Trips;
        },
        get_Trips_for_Gtag(): booking_info[]  {
            let Trips: booking_info[] = [];
            this.get_booking()?.trips?.forEach((Trip:booking_info) => {
                if (Trip.booking_info?.booking_channel?.toLowerCase() === "web - direct") {
                    alert("Web Direct Trip: " + Trip.tour_name);
                    Trips.push(Trip);
                }
            });

            return Trips;
        },
        passenger_info(passenger: client_booking): string {
            return Book.get_Passenger(passenger.passenger_identifier, this.get_booking());
        },
        get_amount_paid(): string {
            return Currency_Services.Format_Currency(Book.get_Paid(this.get_booking()), this.$store.getters.get_Currency);
        },
        get_payment_status_summary(): string {
            if(this.is_fully_paid()) {
                return "Fully Paid";
            }
            if(this.is_part_paid()) {
                return "Part Paid";
            }
            if(this.is_not_paid()) {
                return "Not Paid";
            }
            return "Unknown";
        },
        get_total_outstanding(): string {
            return Currency_Services.Format_Currency(Book.get_total_outstanding(this.get_booking()), this.$store.getters.get_Currency);
        },
        get_booking(): booking_search_group {
            return this.$store.getters.get_Payment_Session.get_booking ?? this.$store.getters.get_Booking;
        },
        Balance_Outstanding(): boolean {
            return Book.get_total_outstanding(this.get_booking()) > 0;
        },
        Get_Paid(): number {
            return Book.get_Paid(this.get_booking());
        },
        is_fully_paid(): boolean {
            return !this.Balance_Outstanding();
        },
        is_part_paid(): boolean {
            return this.Get_Paid() > 0 && this.Balance_Outstanding();
        },
        is_not_paid(): boolean {
            return this.Get_Paid() === 0 && this.Balance_Outstanding();
        },
        gtag_purchase() {
            const storageKey = `purchase_fired_${this.group_booking_id}`;

            if (!this.gtag_purchased && this.group_booking_id && !sessionStorage.getItem(storageKey)) {
                this.gtag_purchased = true;
                sessionStorage.setItem(storageKey, '1');
                
                var allItems: [] = [];
                let index = 0;
                let totalPrice = 0;
                this.get_Trips_for_Gtag().forEach(trip => {
                    let adult_count = 0;
                    let child_count = 0;
                    let senior_count = 0;
                    let student_count = 0;
                    let adult_price = 0;
                    let child_price = 0;
                    let senior_price = 0;
                    let student_price = 0;


                    trip.passengers.forEach(passenger => {
                        let ageCategory = Book.get_Passenger_Age_Cat(passenger?.passenger_identifier, this.get_booking());
                        if (ageCategory.toLowerCase().includes("adult")) {
                            adult_count++;
                            adult_price += passenger.price;
                            totalPrice += passenger.price;
                        }
                        else if (ageCategory.toLowerCase().includes("child")) {
                            child_count++;
                            child_price += passenger.price;
                            totalPrice += passenger.price;
                        }
                        else if (ageCategory.toLowerCase().includes("senior")) {
                            senior_count++;
                            senior_price += passenger.price;
                            totalPrice += passenger.price;
                        }
                        else if (ageCategory.toLowerCase().includes("student")) {
                            student_count++;
                            student_price += passenger.price;
                            totalPrice += passenger.price;
                        }
                    });

                    var product_details = Prod.Get_Details_Sync(trip?.tour_id, this.$store);
                    if(adult_count > 0)
                    {
                        allItems.push(this.gtag_make_item(index, product_details.tour_id, product_details.name, index, adult_count, adult_price/adult_count, "adult"));
                    }
                    if(child_count > 0)
                    {
                        allItems.push(this.gtag_make_item(index, product_details.tour_id, product_details.name, index, child_count, child_price/child_count, "child"));
                    }
                    if(senior_count > 0)
                    {
                        allItems.push(this.gtag_make_item(index, product_details.tour_id, product_details.name, index, senior_count, senior_price/senior_count, "senior"));
                    }
                    if(student_count > 0)
                    {
                        allItems.push(this.gtag_make_item(index, product_details.tour_id, product_details.name, index, student_count, student_price/student_count, "student"));
                    }
                
                    index++;
                });

                window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                window.dataLayer.push({
                    event: "purchase",
                    ecommerce: {
                        transaction_id: String(this.group_booking_id),
                        currency: this.$store.getters.get_Currency.currency_info.iso_currency_code,
                        value: totalPrice,
                        items: allItems
                    }
                });
            }
        },
        trim_trip_name(name: string, id: string): string {
            return name.replace("(" + id + ")", "").trim();
        },
        gtag_make_item(index: number, tour_id: string, tour_name: string, trip_index: string, paxCount: number, paxPrice: number, paxType: string) {

            let lengthCategory = "1 Day Tours";
            if(parseInt(Prod.product_durationInDays(Prod.Get_Details_Sync(tour_id, this.$store)).replace(" days", "").replace(" day", "")) > 1){
                lengthCategory = "3-8 Day Tours";
            }

            var catOne = Prod.product_durationInDays(Prod.Get_Details_Sync(tour_id, this.$store));
            if(catOne.toLowerCase() == "1 Day Tours"){
                catOne = "AddOn";
            }

            let product_details = Prod.Get_Details_Sync(tour_id, this.$store);

            var item = {
                item_id: tour_id,
                item_name: product_details.name,
                affiliation: import.meta.env.VITE_DEFAULT_TAB_TEXT + " Booking Engine",
                coupon: this.$store.getters.get_Booking?.trips[trip_index]?.promo_code,
                index: index,
                item_brand: import.meta.env.VITE_DEFAULT_TAB_TEXT,
                item_category: catOne,
                item_category2: lengthCategory,
                item_category3: Prod.product_start_location(product_details),
                item_category4: paxType,
                item_list_name: lengthCategory,
                price: paxPrice,
                quantity: paxCount
            };

            return item;
        },
        GetBrand(): string {
             return String(import.meta.env.VITE_DEFAULT_CLASS);
        },
        get_conversion_purchase_tag() {
            return String(import.meta.env.VITE_DEFAULT_PURCHASE_TAG);
        },
        get_conversion_price(): string {
            return  String(Book.get_total_price(this.get_booking(), this.$store));
        },
        get_conversion_currency(): string {
            return this.$store.getters.get_Currency.currency_info.iso_currency_code;
        },
        get_conversion_transaction(): string {
            return this.group_booking_id.toString();
        },
        provider_payment_confirmation_notify_iframe_confirmation_for_redirect() {
            let is_top_window = window === top;
            let is_cyberource = import.meta.env.VITE_PAYMENT_METHOD == 'cybersource';
            let is_stripe = import.meta.env.VITE_PAYMENT_METHOD == 'stripe';
            if (!is_top_window && (is_cyberource || is_stripe)) {
                let data = {
                    frame: "provider_payment_confirmation",
                    booking: this.group_booking_id,
                    status: "RESPONSE"
                }
                if (window.top != null) window.top?.postMessage({"data": data}, import.meta.env.VITE_DEFAULT_URL);
            }
        }
    },
    async mounted() {
        await this.download_booking();
        this.provider_payment_confirmation_notify_iframe_confirmation_for_redirect();        
    }
})